import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CalendarSearchSelect.html?raw';
import on from 'dojo/on';
import topic from 'dojo/topic';
import _LabelInputBase from '../../_LabelInputBase/_LabelInputBase';
import _InputMultiBase from '../../_InputMultiBase/_InputMultiBase';
//import DataItems = require("DataItems");


interface option { value: any, entity: object, optionNode: HTMLElement, optionSelectorNode: HTMLElement, label: string, selected: boolean}
class CalendarSearchSelect extends compose(_InputMultiBase) {
    templateString: any = template;
    //===================== Nodes START
    outerInput: HTMLInputElement;
    input: HTMLInputElement;
    openDropdownBtn: HTMLElement;
    dropdownContainer: HTMLElement;
    closeDropdownBtn: HTMLElement;
    scrollContainer: HTMLElement;
    noResultsContainer: HTMLElement;
    btnSelectNone: HTMLElement;
    btnSelectAll: HTMLElement;
    btnShowSelected: HTMLElement;
    btnConfirm: HTMLElement;
    //===================== Nodes END

    currentFocus: number = null;

    isEditModeActive: boolean = false;

    isShowSelectedMode: boolean = false;

    labelAttribute: string = null;
    valueAttribute: string = "ID"; // Vorgabewert
    suggestionLabelAttribute: string = null;

    dateFrom: Date = null;
    dateTo: Date = null;
    dateLimit_inMonths: number = 12;
    dateMax: Date;
    dateMin: Date;

    keyword: string = null;
    cid: string = null;
    activeFilters: Array<string> = [];
    resetOnEdit: boolean = false; // das Entity zurücksetzen wenn der Benutzer eine Eingabe macht (also Inputfeld irgendwie reintippt)

    __request: any = null;
    __searchDelay: number = null;
    __confirmDelay: number = null;

    entities: Array<object> = [];
    optionsRegistry: Array<option> = [];
    _selectedValue: any = null;
    _selectedEntity: object = null;
    _oldSelection: string | any = "-x"; // ändert sich auch wenn nach erstem Laden "nichts" gewählt ist

    url: string = null;

    dataformat: string = "json"; // wird für Request und Response benötigt (pithelper)
    readonly: boolean = false;

    detailReferenceParameter: string = "startTime"; //// bei constructOption das paramater, das dem Label hizugefügt wird für mehr details (wie z.B. Datum);
    dataSortingOrder: "DESC" | "ASC" = "DESC";

    _setPlaceholderAttr(value:string):void {
        this.UiModder.domAttr.set(this.input, "placeholder", value);
    }

    _setReadonlyAttr(value:boolean):void {
        this.readonly = value !== false;

        var classFct1: Function = this.UiModder.domClass.add;
        var classFct2: Function = this.UiModder.domClass.remove;

        if (this.readonly == true) {
            classFct1 = this.UiModder.domClass.remove;
            classFct2 = this.UiModder.domClass.add;
        }

        classFct2(this.outerInput, "w3-disabled");
        classFct2(this.openDropdownBtn, "w3-disabled");
        classFct1(this.openDropdownBtn, "mds-hover-dark");
    }

    _setMandatoryAttr(value:boolean):void {
        this.isMandatory = value;
        //this.checkValidity();
    }

    _setEditModeAttr(bActive:boolean):void {
        if (this.readonly == true) {
            return;
        }

        if (bActive !== false) {
            bActive = true;
        }

        if (this.isEditModeActive != bActive) {
            this.isEditModeActive = bActive;
            this.setEditModeStyle();

            if (this.isEditModeActive == true) {
                // die bisherige Auswahl als Backup wegspeichern
                this._oldSelection = null;

                this._oldSelection = this._selectedValue;


                this.btnSelectNone.scrollIntoView({
                    behavior: "smooth"
                    //block: "end",
                });
            } else {
                this._selectedValue = this._oldSelection;
                this.input.value = null;
                this._handleSearch();
            }
        }

        //console.log("_setEditModeAttr", bActive, this._selectedValues);
    }

    _setDataFormatAttr(value:string):void {

        if (value != "pit" && value != "json") {
            value = "json";
        }

        this.dataformat = value;

        this.PitHelper._structureFormat = this.dataformat;
    }

    _getValueAttr(bReturnEntities:boolean):any{
        if (bReturnEntities === true) {
            return this._selectedEntity;
        }

        return this._selectedValue;
    }

    _setValueAttr(value : any):void {

        //console.log("multiselectbox _setValueAttr", value);
        this._selectedValue = null;

        if (typeof (value) == "object") {

            this._selectedValue = this.PitHelper.getEntityAttributeValue(value, this.valueAttribute);

        } else if (typeof (value) == "string") {
            this._selectedValue = value;
        }

        this._adjustSelectionStyle();
        this.updateCurrentSelectedValues();

    }

    _loadListValues():void {
        if (this.cid && this.activeFilters && this.activeFilters.length) {

            var url:string;
            if (this.url == null) {

            } else {
                url = this.url;
            }


            if (this.__request != null) {
                //console.log("selectbox: request cancel");
                if (typeof this.__request.cancel == 'function'){
                    this.__request.cancel();
                }else if (typeof this.__request.abort == 'function'){
                    this.__request.abort();
                }
                this.__request = null;
            }

            this.StandbyStart();

            var requestParams:object = {};

            if (this.dateMin) {
                requestParams["start"] = this.dateMin;
            }
            if (this.dateFrom) {
                requestParams["start"] = this.dateFrom;
            }
            if (!requestParams["start"]) {
                console.log("NO START DATE PARAM");
                return;
            }

            if (this.dateMax) {
                requestParams["end"] = this.dateMax;

            }
            if (this.dateTo) {
                requestParams["end"] = this.dateTo;
            }
            if (!requestParams["end"]){
                console.log("NO END DATE PARAM");
                return;
            }

            if (this.keyword) {
                requestParams["keyword"] = this.keyword;
            } else {
                requestParams["keyword"] = this.input.value;
            }
            if (!requestParams["keyword"]) {
                console.log("NO KEYWORD");
                return;
            }

            requestParams["cid"] = this.cid
            requestParams["filters"] = this.activeFilters;

            var requestUrl:string = window.appRoot + url;

            //console.log("CALENDAR SEARCH REQUESTPARAMS :", requestParams);

            this.__request = this.RequestManager.post(  // ============================================================================= REQUEST
                requestUrl,
                {
                    "jsonData": JSON.stringify(requestParams)
                },
                lang.hitch(this, "_onLoadListValuesResponse"),
                lang.hitch(this, "_onLoadListValuesError"),
                false // sync
            );

        }
    }

    _onLoadListValuesResponse(response:any):void { // responsecallback
        //console.log("_onLoadListValuesResponse - response ", response);
        this.__request = null;

        this.isShowSelectedMode = false;

        if (response && response.items) {
            this.entities = response.items;

            this._onClick_SelectNone(); // das war ein select-none-nutton hab es auf die schnelle umgeaut --- TODO: umbenenen

        } else {
            console.log("Fasches Dataformat beim Response");
        }

        this.StandbyStop();

        //this._handleSearch();
    }

    sortData(propertyName: string, sortDirection: "DESC" | "ASC"): void {


        let compareFuction: any;
        let this_smogler: any = this;

        // wenn es einen Gruppierungsparam gibt
        if (propertyName) {
            let attrValue: string;

            //eine beliebige Value finden, um den Type zu kennen
            for (let i = 0; i < this.entities.length; i++) {
                attrValue = this.PitHelper.getEntityAttributeValue(this.entities[i], propertyName, more.PitHelperStructureFormatType.json);
                if (attrValue) { break; }

            }

            if (!isNaN(Number(attrValue))) {
                // wenn es eine Zahl ist
                if (sortDirection == "DESC") {

                    compareFuction = function (a, b) {
                        let result: any = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json) -
                            this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json);
                        return result;
                    }

                } else {

                    compareFuction = function (a, b) {
                        let result: any = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json) -
                            this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json);
                        return result;
                    }

                }

            } else {

                //wenn es ein String ist

                if (sortDirection == "DESC") {
                    compareFuction = function (a, b) {
                        let fa = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        let fb = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        if (fa < fb) {
                            return 1;
                        }
                        if (fa > fb) {
                            return -1;
                        }
                        return 0;
                    }
                } else {
                    compareFuction = function (a, b) {
                        let fa = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        let fb = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    }
                }
            }

            this.entities.sort(compareFuction);

        } else {
            alert("no grouping parameter!")
        }

        this._constructOptions();
    }

    _onLoadListValuesError(err: string | object):void { // errorCallback
        console.error("_onLoadListValuesError", err);
        this.__request = null;
        if (typeof (err) == "object") {
            alert(err["Message"]);
        } else {
            alert(err);
        }
        this.StandbyStop();
    }

    _constructOptions(bUpdateSelection?:boolean ): void {
        this.UiModder.domConstruct.empty(this.scrollContainer);

        this.optionsRegistry = [];

        var bOnlySelected:boolean = this.isShowSelectedMode == true;

        // aus den geladenen Daten die selects erstellen
        if (this.entities != null) {
            for (var i = 0; i < this.entities.length; i++) {
                var entity: object = this.entities[i];

                this.constructOption(entity, bOnlySelected);
            }
        }

        if (bUpdateSelection !== false && bUpdateSelection !== true) {
            bUpdateSelection = true;
        }

        //this.set("value";
        this._adjustSelectionStyle();

        if (bUpdateSelection == true) {
            this.updateCurrentSelectedValues();
        }
    }

    constructOption(entity: object, bOnlySelected): void {

        var value:any = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute, "json");
        var label:string = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute, "json");
        if (this.labelAttribute != "" && this.labelAttribute != null) {
            label = this.PitHelper.getEntityAttributeValue(entity, this.detailReferenceParameter, "json").substring(0, 10) + " | " + this.PitHelper.getEntityAttributeValue(entity, this.labelAttribute, "json");
        }


        var option: HTMLElement = this.UiModder.domConstruct.create("div", { className: "mds-hover-dark" }, this.scrollContainer);
        //domClass.add(option, "selectbox-items");
        this.UiModder.domClass.add(option, "flex_row_center");

        var optionSelector: HTMLElement = this.UiModder.domConstruct.create("div", { innerHTML: "<i class='fa fa-circle-o' aria-hidden='true'></i>" }, option);
        this.UiModder.domClass.add(optionSelector, "w3-padding-small");

        var optionLabel: HTMLElement = this.UiModder.domConstruct.create("div", { innerHTML: label, style: { "flex": "1" } }, option);
        this.UiModder.domClass.add(optionLabel, "w3-padding-small");


        var registryEntry: option = { value: value, entity: entity, optionNode: option, optionSelectorNode: optionSelector, label: label, /*visible: bShow,*/ selected: this._selectedValue == value };
        this.optionsRegistry.push(registryEntry);

        on(option, "click", lang.hitch(this, this._onClick_Option, registryEntry));
    }

    delayedHandleSearch():void {
        if (this.__searchDelay != null) {
            clearTimeout(this.__searchDelay);
            this.__searchDelay = null;
        }

        this.__searchDelay = setTimeout(lang.hitch(this, this._handleSearch), 1000);
    }


    _handleSearch():void {

        this.__searchDelay = null;

        if (this.input.value) {
            this._loadListValues();
        }

    }


    updateCurrentSelectedValues() :void {
        this._selectedValue = null;
        this._selectedEntity = null;

        var textValue:string = "";

        for (var i = 0; i < this.optionsRegistry.length; i++) {
            var option:option = this.optionsRegistry[i];

            if (option.selected == true) {
                this._selectedValue = option.value;
                this._selectedEntity = option.entity;


                textValue = textValue + option.label;
            }
        }

        this.outerInput.value = textValue;

    }

    _adjustSelectionStyle(targetOption?:option):void {
        var optionsList: option[] = this.optionsRegistry;

        if (typeof (targetOption) != "undefined") {
            optionsList = [targetOption];
        }

        for (var i = 0; i < optionsList.length; i++) {
            var option = optionsList[i];
            option.selected = false;
            var iconHTML = iconHTML = "<i class='fa fa-circle-o' aria-hidden='true'></i>";
            if (this._selectedValue == option.value) {
                iconHTML = "<i class='fa fa-check-circle' aria-hidden='true'></i>";
                option.selected = true;
            }


            this.UiModder.domAttr.set(option.optionSelectorNode, "innerHTML", iconHTML);
        }

    }

    _setupEventListener():void {

        document.addEventListener("click", lang.hitch(this, "toggleEditmode", false));

        on(this.domNode, "click", lang.hitch(this, function (e) {
            e.stopPropagation();
        }))
    }

    _onKeyDown_Input(evt: KeyboardEvent):void {
        var x: HTMLElement | HTMLCollectionOf<HTMLElement> = this.scrollContainer;

        if (x) x = x.getElementsByTagName("div");
        if (evt.keyCode == 40) {
            this.currentFocus++;

        } else if (evt.keyCode == 38) { //up
            this.currentFocus--;

        } else if (evt.keyCode == 13) {
            evt.preventDefault();

        } else if (evt.keyCode == 27) { //esc
            if (this.input.value) {
                this.input.value = null;
                return;
            }
            this.set("editMode", false);
        }
    }

            // wenn ein Benutzer einen Hint auswählt, aber danach die Inputbox ändert, kann evtl ja die ganze Auswahl ungültig sein
    // deswegen einmalig ein Event auslösen
    _onKeyUp_Input(evt: KeyboardEvent):void {

        this.delayedHandleSearch();
    }



    _onClick_OuterInput(evt: MouseEvent):void {
        // wenn möglich: bei Klick ins Eingabefeld gleich in den "Editiermodus" wechseln
        this.set("editMode", true);

    }

    _onClick_DropDown(evt: MouseEvent):void {
        this.toggleEditmode();
    }

    toggleEditmode(targetState?:boolean):void {

        if (typeof (targetState) == "undefined") {
            targetState = this.isEditModeActive !== true;
        }

        if (targetState === true) {
            this.set("editMode", true);
        } else {
            this.confirmSelection(false);
            this.set("editMode", false);
        }
    }

    setEditModeStyle(): void {
        var classFunc1: Function = this.UiModder.domClass.remove;
        var classFunc2: Function = this.UiModder.domClass.add;
        if (this.isEditModeActive == true) {
            classFunc1 = this.UiModder.domClass.add;
            classFunc2 = this.UiModder.domClass.remove;
        }

        //Anm: vom Normalfall "kein Editmodus" ausgehen:
        // classFunc2 fügt Klassen hinzu
        //
        classFunc2(this.dropdownContainer, "w3-hide");
        //classFunc1(this.outerInput, "w3-hide");

        if (this.isEditModeActive == true) {
            this.input.focus();
        }
    }

    _onClick_Option(option: option, evt: MouseEvent):void {

        if (this.readonly === true) {
            return;
        }

        for (var i = 0; i < this.optionsRegistry.length; i++) {
            this.selectOption(this.optionsRegistry[i], false);
        }

        this.selectOption(option, !option.selected);

    }

    selectOption(option:option, targetState:boolean):void {
        //if (option.visible == true) {
            option.selected = targetState;
        //}
        this.updateCurrentSelectedValues();
        this._adjustSelectionStyle(option);

        this.delayedConfirmSelection(false, 1888);

        //console.log("selectOption", option, this._selectedValues);
    }

    _onClick_ShowSelected(evt: MouseEvent):void {

        //console.log("SELECTED ENTITY: ", this._selectedEntity);

        if (this._selectedEntity) topic.publish("calendarSearchSelect/showEntity", this._selectedEntity);

        this.isShowSelectedMode = !this.isShowSelectedMode;

    }


    delayedConfirmSelection(bSuppressChange:boolean, delay:number):void {
        if (typeof (delay) != "number") {
            delay = 500;
        }

        if (this.__confirmDelay != null) {
            clearTimeout(this.__confirmDelay);
            this.__confirmDelay = null;
        }

        this.__confirmDelay = setTimeout(lang.hitch(this, this.confirmSelection, bSuppressChange), delay);
    }

    confirmSelection(bSuppressChange?:boolean):void {

        if (this._oldSelection && this._selectedValue) {
            var oldValuestxt:string = this._oldSelection.toString();
            var newValuestxt:string = this._selectedValue.toString();
            if (this.__confirmDelay != null) {
                clearTimeout(this.__confirmDelay);
            }
            this.__confirmDelay = null;

            if (newValuestxt != oldValuestxt && bSuppressChange != true) {
                this.emit("change", this._selectedValue);
            }

            this._oldSelection = this._selectedValue;
        }


    }

    _onClick_SelectNone(evt?: MouseEvent):void {

        //if (this.readonly === true) {
        //    return;
        //}

        //for (var i = 0; i < this.optionsRegistry.length; i++) {
        //    this.selectOption(this.optionsRegistry[i], false);
        //}

        //this.isShowSelectedMode = false;

        let order: "DESC" | "ASC";

        if (this.dataSortingOrder == "DESC") {
            order = "ASC";
            this.dataSortingOrder = "ASC";
        } else {
            order = "DESC";
            this.dataSortingOrder = "DESC";
        }

        this.sortData(this.detailReferenceParameter, order);
    }


    setDateLimit_inMonth(value: number): void {
        let dateNow: Date = new Date();
        let months: number;
        if (value && typeof value == "number") {
            months = value;
            this.dateLimit_inMonths = value;
        } else if (this.dateLimit_inMonths && typeof this.dateLimit_inMonths == "number") {
            months = this.dateLimit_inMonths;
        }

        if (months) {
            this.dateMax = new Date(dateNow.setMonth(dateNow.getMonth() + months));
            var dateVariable:Date = new Date();
            dateVariable.setMonth(dateVariable.getMonth() - months);
            this.dateMin = dateVariable;
        }

    }

    _onchangeDateRange():void {
        this._loadListValues();
    }

    _setDateFromAttr(date: Date): void{
        if (date) {
            this.dateFrom = date;
        } else {
            this.dateFrom = null;
        }
        this._onchangeDateRange();
    }

    _setDateToAttr(date:Date): void {
        if (date) {
            this.dateTo = date;
        } else {
            this.dateTo = null;
        }
        this._onchangeDateRange();
    }

    _setActiveFiltersAttr(activeFilters: string[]): void {
        this.activeFilters = activeFilters;
        if (this.input.value) {
            this._loadListValues();
        }

    }


    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any);
    }

    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.outerInput, "outerInput");
        this.setDataCyAttribute(this.input, "input");
        this.setDataCyAttribute(this.openDropdownBtn, "openDropdownBtn");
        this.setDataCyAttribute(this.closeDropdownBtn, "closeDropdownBtn");
        this.setDataCyAttribute(this.btnSelectNone, "btnSelectNone");
        this.setDataCyAttribute(this.btnSelectAll, "btnSelectAll");
        this.setDataCyAttribute(this.btnShowSelected, "btnShowSelected");
        this.setDataCyAttribute(this.btnConfirm, "btnConfirm");
    }

    postCreate() {
        super.postCreate.apply(this, arguments as any);

        this._selectedValue = null;

        this.PitHelper._structureFormat = this.dataformat;

        this._setupEventListener();

    }

    startup() {
        super.startup.apply(this, arguments as any);

        topic.subscribe("UserProperties/calendarConfig", lang.hitch(this, function (currentCalendarConfig) {

            this.cid = currentCalendarConfig.ID;
            if (this.input.value) {
                this._loadListValues();
            }
        }));

    }
    destroy() {
        super.destroy.apply(this, arguments as any);
    }


}

export default mdsWidget(CalendarSearchSelect);
